import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { LegalLang } from '../../shared/legal-lang-toggle/legal-lang-toggle.component';
import { environment } from '../../../environments/environment';

/**
 * Public account-deletion page for BoothPilot Replay.
 *
 * Google Play requires apps that allow account creation to publish a web URL
 * where deletion can be requested without installing the app, in addition to the
 * in-app flow. This page is that URL, so it must stay unguarded and reachable to
 * anonymous visitors.
 */
@Component({
    selector: 'app-delete-account',
    templateUrl: './delete-account.component.html',
    styleUrls: ['./delete-account.component.scss'],
    standalone: false
})
export class DeleteAccountComponent implements OnInit, OnDestroy {

  // Local to this page, matching PrivacyComponent — see LegalLangToggleComponent.
  lang: LegalLang = 'en';

  constructor(private titleService: Title, private route: ActivatedRoute) { }

  ngOnInit() {
    document.body.classList.add('background');
    // Supports sharing a French link, e.g. /delete-account?lang=fr
    if (this.route.snapshot.queryParamMap.get('lang') === 'fr') {
      this.lang = 'fr';
    }
    this.setTitle();
  }

  onLangChange(lang: LegalLang) {
    this.lang = lang;
    this.setTitle();
  }

  private setTitle() {
    const name = this.lang === 'fr' ? 'Suppression de compte' : 'Account Deletion';
    this.titleService.setTitle(`${name} | ${environment.appName}`);
  }

  ngOnDestroy() {
    document.body.classList.remove('background');
  }

}
